import { useDispatch } from "react-redux";
import { setAngle, setFullWidth, setWidth } from "../store/deviceSizeSlice";
import { useDebounceCallback, useEventListener } from "usehooks-ts";

export default function useDeviceSizeFill() {
  const dispatch = useDispatch();

  const checkSizeWindow = async () => {
    dispatch(setAngle(screen?.orientation?.angle));
    if (!window.innerWidth) return;
    dispatch(setFullWidth(window.outerWidth));
    dispatch(setWidth(window.innerWidth));
    dispatch(setAngle(screen?.orientation?.angle));
  };

  const debouncedCheckSizeWindow = useDebounceCallback(checkSizeWindow, 200);

  useEventListener("resize", debouncedCheckSizeWindow);
}
